import React, { useCallback } from 'react'
import { Card } from '../../../../../../shared/card/card'
import { AIToolsSharing } from '../../../../../../shared/ai-tools-sharing/ai-tools-sharing'
import { getOrgSetting, setOrgSetting } from '../../../../../../shared/ai-tools-sharing/api'
import { useRoleSysOrganization } from '../../../../../../role/hook/role-sys'

// Whether this organization allows AI tools usage data (owner decision
// 2026-10-23), on its system page: staff read it with SYS_ORGANIZATION read
// and change it with update (content's GET / PUT /organization/:id/setting).
// The organization's owners change the same switch on their own page.
export const AIToolsSharingCard = ({ organizationID }) => {
  const role = useRoleSysOrganization()
  const load = useCallback(() => getOrgSetting(organizationID), [organizationID])
  const save = useCallback(allowed => setOrgSetting(organizationID, allowed), [organizationID])
  if (!organizationID || !role.accessRead) return null
  return (
    <section aria-label="AI tools">
      <Card title="AI tools">
        <AIToolsSharing load={load} save={save} canUpdate={!!role.accessUpdate} whyNot="Changing it needs the organization update permission." />
      </Card>
    </section>
  )
}
